import { AllowedCourseItem } from '../../types';

export function findImmediateNextChallengeCourse(currentCourseId: string, allowedCourses: AllowedCourseItem[]) {
  // Find the index of the course with the given course ID
  const currentIndex = allowedCourses.findIndex(
    (course) => course.course_id === currentCourseId,
  );

  // If the course isn't found or if it's the last course in the array, return null
  if (currentIndex === -1 || currentIndex === allowedCourses.length - 1) {
    return null;
  }

  // Check if the immediate next course has a type of '5-day-challenge'
  const nextCourse = allowedCourses[currentIndex + 1];
  if (nextCourse.type === '5-day-challenge') {
    return nextCourse;
  }

  // If the immediate next course is not a 5-day challenge, return null
  return null;
}
